import { useTranslation } from 'react-i18next';

import { setLanguage } from '@/api/client';
import { useUserStore } from '@/store/userStore';

const STORAGE_KEY = 'i18nextLng';

export default function LangToggle() {
  const { i18n } = useTranslation();
  const setUser = useUserStore((s) => s.setUser);
  const user = useUserStore((s) => s.user);

  const current: 'ru' | 'en' = i18n.language.startsWith('ru') ? 'ru' : 'en';

  const set = async (lang: 'ru' | 'en') => {
    if (lang === current) return;

    // 1. Persist choice — survives the reload, also picked up by X-Language header.
    try { localStorage.setItem(STORAGE_KEY, lang); } catch {}

    // 2. Flip i18n so the UI updates immediately.
    i18n.changeLanguage(lang);

    // 3. Wait for backend to update user.language in DB so AI generates
    //    in the correct language after reload. If it fails (offline/dev),
    //    reload anyway — X-Language header will carry the right language.
    try {
      await setLanguage(lang);
      if (user) setUser({ ...user, language: lang });
    } catch {}

    // 4. Reload so cached server-side content (daily card etc.) re-fetches.
    window.location.reload();
  };

  const cell = 'rounded-full px-3 py-1 text-xs font-medium transition';
  const active = 'bg-gold-500 text-night-900';
  const idle = 'text-gold-300/70 hover:text-gold-300';

  return (
    <div className="inline-flex items-center rounded-full border border-gold-500/30 bg-night-800/80 backdrop-blur">
      <button
        type="button"
        className={`${cell} ${current === 'ru' ? active : idle}`}
        onClick={() => set('ru')}
      >
        RU
      </button>
      <button
        type="button"
        className={`${cell} ${current === 'en' ? active : idle}`}
        onClick={() => set('en')}
      >
        EN
      </button>
    </div>
  );
}
